export function map(obj, action) {
  for (let key in obj) {
    action(obj[key]);
  }
}

export function mapKV(obj, action) {
  for (let key in obj) {
    action(key, obj[key]);
  }
}

export function asArray(obj) {
  let array = [];
  for (let key in obj) {
    array.push({ key, ...obj[key] });
  }
  return array;
}

export function asSimpleArray(obj) {
  let array = [];
  for (let key in obj) {
    array.push(obj[key]);
  }
  return array;
}
